import React, { FC, ReactNode, MouseEvent } from 'react';
import { Tag as ChakraUITag, TagLabel, TagCloseButton } from '@chakra-ui/react';
import { TagVariant, TagSize } from './types';
import { Icon, IconProps } from '../Icon';

export interface TagProps {
  closeClick?: (event: MouseEvent) => void;
  variant?: TagVariant;
  colorScheme?: string;
  tagLabel?: string;
  isClosable?: boolean;
  size?: TagSize;
  children?: ReactNode;
  onClick?: (event: MouseEvent) => void;
  textStyle?: string;
  isRound?: boolean;
  leftIcon?: IconProps;
  rightIcon?: IconProps;
  leftImage?: React.ReactNode;
  rightImage?: React.ReactNode;
  as?: React.ElementType;
}

export const Tag: FC<TagProps> = ({
  closeClick,
  onClick,
  variant,
  colorScheme,
  tagLabel,
  isClosable,
  isRound,
  size,
  children,
  leftIcon,
  rightIcon,
  leftImage,
  rightImage,
}: TagProps) => {
  /**
   * DOM
   */

  return (
    <ChakraUITag
      variant={variant}
      size={size}
      colorScheme={colorScheme}
      data-object-type="tag"
      {...(isRound && { rounded: 'full' })}
      {...(onClick && { onClick, as: 'button', cursor: 'pointer' })}
    >
      {leftImage || (leftIcon && <Icon {...leftIcon} />)}
      {!!tagLabel && <TagLabel>{tagLabel}</TagLabel>}
      {children}
      {rightImage || (rightIcon && <Icon {...rightIcon} />)}
      {!!isClosable && <TagCloseButton onClick={closeClick} {...(isRound && { rounded: 'full' })} />}
    </ChakraUITag>
  );
};
